// ============================================================
// TeamNotFound — prikazuje se kad slug iz URL-a ne postoji u bazi.
// Koristi se kao fallback za /t/:slug rute kad TeamContext vrati error.
// ============================================================

import React from 'react';
import { Link, useParams } from 'react-router-dom';
import '../App.css';

const TeamNotFound = () => {
  const { slug } = useParams();

  return (
    <div className="empty-state" style={{ margin: 60, textAlign: 'center' }}>
      <h2 style={{ marginBottom: 8 }}>Tim nije pronađen</h2>
      <p style={{ color: 'var(--text-3)', marginBottom: 20 }}>
        Tim s oznakom <code>{slug}</code> ne postoji ili je privatan.
      </p>
      <Link to="/directory" className="btn btn-primary">
        Natrag na direktorij
      </Link>
    </div>
  );
};

export default TeamNotFound;
